import {Injectable} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class IconRegistryService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  registerCustomIcons() {
    {
      this.matIconRegistry.addSvgIcon(
        'password',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/Password.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'username',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/Username.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'account_circle',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/MyAccount.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'login',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/Login.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'delete',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/Delete.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'info',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/info.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'success-white',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/Success_White.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'warning',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/baseline-warning-24px.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'unReadAlerts',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/alerts.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'unReadCriticalAlerts',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/critical-alerts.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'alerts',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/info.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'unread_alerts',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/alert-triangle_unread.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'unread_critical_alerts',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/alert-triangle_unread_critical.svg'
        )
      );
    }
  }
  registerCustomIconsNavigation() {
    {
      this.matIconRegistry.addSvgIcon(
        'apps',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/sidebar_header/apps.svg'
        )
      );

      this.matIconRegistry.addSvgIcon(
        'clients',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/sidebar_header/clients.svg'
        )
      );

      this.matIconRegistry.addSvgIcon(
        'credit-card',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/sidebar_header/credit-card.svg'
        )
      );

      this.matIconRegistry.addSvgIcon(
        'helpandsupport',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/sidebar_header/helpandsupport.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'taxes',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/sidebar_header/taxes.svg'
        )
      );


      this.matIconRegistry.addSvgIcon(
        'search',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/sidebar_header/search.svg'
        )
      );

      this.matIconRegistry.addSvgIcon(
        'settings',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/sidebar_header/settings.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'global_settings',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/sidebar_header/global_settings.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'notifications',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/sidebar_header/notifications.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'alert_message',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/sidebar_header/mail.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'myaccount',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/sidebar_header/myaccount.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'coin',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/Coin.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'more',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/More.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'edit',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/Edit.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'crown',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/Crown.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'clientaccess',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/clientaccess.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'credits',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/credits.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'credits_dark',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/credits_dark.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'invite_email_white',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/InviteEmail_White.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'invite_email',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/InviteEmail.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'arrowDropDown',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/DropDownArrow_White.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'calendar',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/Calendar.svg'
        )
      );
    this.matIconRegistry.addSvgIcon(
        'download',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/Download.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'wifi',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/Connect_White.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'windows',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/Windows_Grey.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'autocorrect',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/Wrench_Grey.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'brandingSettings',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/BrandingSettings_Grey.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'logout',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/LogOut_Grey.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'myAccount',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/MyAccount_Grey.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'filter_white',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/Filter_White.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'usermanagement',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../../../../assets/icons/User Management_Grey.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'export',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/icons/Export.svg'
        )
      );

      this.matIconRegistry.addSvgIcon(
        'attach',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/icons/Attach.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'upgrade',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/icons/Upgrade.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'detach',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/icons/Detach.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'disconnect',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/icons/disconnect.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'openconnect',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/icons/openconnect.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'connect',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/icons/connect.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'clientCreateInfo',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/icons/client-create-info.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'back-arrow',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/icons/back-arrow.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'alert-danger',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/icons/alert-danger.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'alert-circle',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/alert-circle.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'success-tick',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/success-tick.svg'
        )
      );
      this.matIconRegistry.addSvgIcon(
        'error-cross',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/error-cross.svg'
        )
      );
    }
  }
}
